<template>
  <div class="t-container page t-px-4 lg:t-px-0">
    <!-- Heading -->
    <span class="page-subheading t-text-xs t-text-gray-600 t-font-medium"
      >HOME</span
    >
    <div class="page-heading mb-5" role="heading">
      <h1 class="page-heading__header">
        Dashboard
      </h1>
    </div>
    <!-- Heading -->
    <section
      class="t-flex-col t-border t-border-gray-100 t-rounded-lg t-shadow-lg t-px-5 t-py-5 t-bg-white"
    >
      <dashboard-carrier-legs-table />
    </section>
  </div>
</template>

<script>
import DashboardCarrierLegsTable from "../../../components/dashboard/components/tables/DashboardCarrierLegsTable";

export default {
  name: "CarrierDashboard",
  components: {
    DashboardCarrierLegsTable
  }
};
</script>
